import React, { useMemo, useState, useContext } from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
// import { Segment } from 'tea-component';
import { context as Context } from '@gp/components/Context';
import PageAccess from '@gp/components/PageAccess';
import KeyIssues from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/KeyIssues';
import Meetings from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/Meetings';
import { getLocationIsValid } from '@gp/utils/common';
import { DESCRIPTION_C } from '@gp/constants/noPermissionTips';

import type { SegmentOption } from 'tea-component/lib/segment/SegmentOption';

import './index.scss';

// function getInitialCurrentSegment(
//   pageAuthorityData?: IStudioPageAuthorityData,
//   defaultExpandedMeetingId?: string | number,
// ): 'keyIssues' | 'boardGovernance' {
//   // 有meetings模块权限
//   const flag1 = pageAuthorityData?.management && pageAuthorityData?.management_boardGovernance;
//   // 存在默认展开的会议记录，有值，且排除value为number类型 并且为0时 被转为falsely的情况
//   const flag2 =
//     defaultExpandedMeetingId || (typeof defaultExpandedMeetingId === 'number' && defaultExpandedMeetingId === 0);
//   const flag3 = !pageAuthorityData?.keyissue && pageAuthorityData?.management_boardGovernance;

//   return (flag1 && flag2) || flag3 ? 'boardGovernance' : 'keyIssues';
// }

const getInitialCurrentSegment = (
  _pageAuthorityData?: IStudioPageAuthorityData,
  _defaultExpandedMeetingId?: string | number,
) => 'boardGovernance';

function useSegmentPage(pageAuthorityData?: IStudioPageAuthorityData, defaultExpandedMeetingId?: string | number) {
  const initialCurrentSegment = getInitialCurrentSegment(pageAuthorityData, defaultExpandedMeetingId);
  const [currentSegment, setCurrentSegment] = useState(initialCurrentSegment);

  const segmentsOptions = useMemo<SegmentOption[]>(
    () => [
      {
        text: 'Key Issues',
        value: 'keyIssues',
        disabled: !pageAuthorityData?.keyissue,
      },
      {
        text: 'Board Governance',
        value: 'boardGovernance',
        disabled: !pageAuthorityData?.management_boardGovernance,
      },
    ],
    [pageAuthorityData],
  );

  const segmentsPages = useMemo<{ [key: string]: React.ReactElement; }>(
    () => ({
      // Key Issues模块
      keyIssues: <KeyIssues />,
      // 董事会议模块
      boardGovernance: <Meetings />,
    }),
    [],
  );

  const handleSegmentChange = useMemoizedFn((value) => {
    setCurrentSegment(value);
  });

  const renderSegmentPage = useMemoizedFn((segment: string) => segmentsPages?.[segment]);

  return {
    currentSegment,
    segmentsOptions,
    handleSegmentChange,
    renderSegmentPage,
  };
}

const StudioManagement: React.FC<IStudioManagementProps> = (props) => {
  const { style, className } = props;

  const filterObj: Record<string, any> = getLocationIsValid('/Studio/PortfolioOverview');

  const {
    // studioId,
    pageAuthorityData,
    // 默认展开的会议id
    meetingId: defaultExpandedMeetingId,
  } = useContext<StudioOverallDetailContextTypes>(Context) || {};

  // const { currentSegment, segmentsOptions, handleSegmentChange, renderSegmentPage } = useSegmentPage(
  //   pageAuthorityData,
  //   defaultExpandedMeetingId || filterObj?.meetingId,
  // );

  const { currentSegment, renderSegmentPage } = useSegmentPage(
    pageAuthorityData,
    defaultExpandedMeetingId || filterObj?.meetingId,
  );

  return (
    <PageAccess isAccess={pageAuthorityData?.management} description={DESCRIPTION_C}>
      <section style={style} className={classnames('font14 dbg-studio-management', className)}>
        {/* <div className="dbg-common-segment-header">
          <Segment
            className="dbg-common-segment segment-light"
            value={currentSegment}
            options={segmentsOptions}
            onChange={handleSegmentChange}
          />
        </div> */}
        {/* 模块UI */}
        {renderSegmentPage(currentSegment)}
      </section>
    </PageAccess>
  );
};

export default React.memo(StudioManagement);
